import { useState } from "react";
import { ApiCall } from "../../../helper/axios";
import moment from "moment";

export const useRecentSearch = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [data, setData] = useState([]);

  const save = async (payload) => {
    let data = payload?.searchData
    let staticData = JSON.parse(sessionStorage.getItem("Cities"))
    data = {
        ...data , cityValueExists : staticData?.find(
          (c) => c?.name === data?.city?.details?.cityName
        )?.code || ""
    }
    try {
      setError(null);
      await ApiCall("POST", "/hotels/recent-search", {searchData : data});
      setLoading(true);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const get = async () => {
    try {
      setError(null);
      const response = await ApiCall("GET", "/hotels/recent-search");
      if (response?.data?.data) {
        const sorted = response?.data?.data?.map(d => d?.data)
        setData(sorted);
      }
      setLoading(true);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    get,
    save,
    data,
    error,
  };
};
